<div class="app-container">
  @if (!hideShell()) {
    <app-header></app-header>
  }

  <main class="app-content" [class.app-content--full]="hideShell()">
    <router-outlet />
    <app-loading-overlay
      [visible]="loadingService.isLoading()"
      [messageKey]="loadingService.messageKey()"
      [indeterminate]="loadingService.indeterminate()"
      [showProgress]="loadingService.showProgress()"
      [currentLoaded]="loadingService.currentLoaded()"
      [total]="loadingService.total()"
      [hasError]="loadingService.hasError()"
      [errorTitleKey]="loadingService.errorTitleKey()"
      [errorDescriptionKey]="loadingService.errorDescriptionKey()"
      [errorSuggestionsHeadingKey]="loadingService.errorSuggestionsHeadingKey()"
      [errorSuggestionKeys]="loadingService.errorSuggestionKeys()"
      [errorRefreshButtonKey]="loadingService.errorRefreshButtonKey()"
      [errorContactButtonKey]="loadingService.errorContactButtonKey()"
      [errorReassuranceKey]="loadingService.errorReassuranceKey()"
      (refresh)="onRefresh()"
      (contactSupport)="onContactSupport()"
    />
  </main>

  @if (!hideShell()) {
    <app-footer></app-footer>
  }
</div>
